import {
  LocationQuestionConfig,
  LocationResponseState,
} from '@gripp/shared-logic';
import { RoutineQuestionModule } from '../types';
import { LocationQuestionAdminForm } from './locationQuestionAdminForm';
import { LocationQuestionExecutionForm } from './locationQuestionExecutionForm';
import { LocationQuestionMessage } from './locationQuestionMessage';

export const LocationQuestionModule: RoutineQuestionModule<
  LocationQuestionConfig,
  LocationResponseState
> = {
  adminForm: LocationQuestionAdminForm,
  executionForm: LocationQuestionExecutionForm,
  message: LocationQuestionMessage,
};
